import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {CustomerService} from '../../customer/services/customer.service';
import {Router} from '@angular/router';
import {PaymentPlanDefaults} from '../model/payment-plan';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {OperationService} from '../service/operation.service';
import {PaymentHubDefaults, PaymentHubService} from '../service/payment-hub.service';
import {PaymentHubComponent} from '../payment-hub.component';
import * as moment from 'moment';

declare var CollectJS: any;

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
    // ----------- labels

    LABEL_ACCOUNT_NUMBER: string;
    LABEL_INVOICE_NUMBER: string;
    LABEL_ACCOUNT_NAME: string;
    LABEL_CUSTOMER: string;
    LABEL_INVOICE_DATE: string;
    LABEL_TERMS: string;

    MESSAGE_OVERPAY_WARNING: string;

    paymentHubDefaults: PaymentHubDefaults;

    username: string;
    transactionId: string;
    type: string;

    formUrl: string;
    billingId: string;
    cards: any;
    wallet: any;
    isEditing: boolean;
    isDisabled: boolean;

    formBankSubmitted: boolean;

    onSubmitLoader: boolean;

    accounts: any;
    invoices: any[];
    totalAmount: any;
    totalAmountBeforeFees: any;
    totalApplicableConvenienceFees: any;
    applicableConvenienceFees: boolean;
    paymentData: any;
    shortPays: any[];
    convenienceFees: any[];
    convenienceFeeObj: any;
    defaultConvenienceFees: any;
    paymentId: any;
    paymentMaxDate: any;
    paymentDate: any;
    wallets: any[];
    adocsBillingId: string;
    singularAccountNumber: string;
    pendingPayments: any[];
    isCcPayment: boolean;
    paymentMethod: any;
    paymentMethod2: any;
    cardReview: any;
    frmBillSubmitted: boolean;
    frmPayMethodSubmitted: boolean;
    formReviewPaySubmitted: boolean;
    invoiceValid: any;
    cardErr: any;
    collectJSFields: any;
    invoicePaymentDate: any;
    response: any;
    refreshIntervalId: any;
    currentDate: any;
    currentDayDatePicker: any;
    selectedPaymentMethod: any;
    achBusinessAccount: any;
    brands: any;
    defaultSettings: any;
    validUsPhoneNumber: any;
    keypadDataLocked: boolean;
    customPay: boolean;


    constructor(private router: Router, private ref: ChangeDetectorRef, private operationService: OperationService,
                private customerService: CustomerService, private paymentHubService: PaymentHubService,
                public paymentHubComponent: PaymentHubComponent, paymentHubDefaults: PaymentHubDefaults,
                private formBuilder: FormBuilder) {
        this.paymentHubService = paymentHubService;
        this.paymentHubDefaults = paymentHubDefaults;
        this.wallets = [];
        this.adocsBillingId = '';
        this.singularAccountNumber = '';
        this.pendingPayments = [];
        this.isEditing = false;
        this.formUrl = '';
        this.billingId = '';
        this.cards = undefined;
        this.brands = [];
        this.username = '';
        this.transactionId = '';
        this.isDisabled = false;
        this.formBankSubmitted = false;
        this.formReviewPaySubmitted = false;
        this.onSubmitLoader = false;
        this.type = 'bill';
        this.isCcPayment = false;
        this.achBusinessAccount = false;
        this.totalAmount = 0;
        this.totalAmountBeforeFees = 0;
        this.totalApplicableConvenienceFees = 0;
        this.applicableConvenienceFees = false;
        this.refreshIntervalId = '';
        this.selectedPaymentMethod = null;
        this.currentDate = moment(new Date()).format('MM/DD/YYYY');
        this.currentDayDatePicker = {
            year: parseInt(moment(new Date()).format('YYYY')),
            month: parseInt(moment(new Date()).format('MM')),
            day: parseInt(moment(new Date()).format('DD'))
        };
        this.paymentMaxDate = {
            year: parseInt(moment(new Date()).days(60).format('YYYY')),
            month: parseInt(moment(new Date()).days(60).format('MM')),
            day: parseInt(moment(new Date()).days(60).format('DD'))
        };
        this.paymentData = {
            invoices: [],
            paymentDate: {
                year: parseInt(moment(new Date()).format('YYYY')),
                month: parseInt(moment(new Date()).format('MM')),
                day: parseInt(moment(new Date()).format('DD'))
            },
            convenienceFee: {
                sid: null,
                comment: ''
            },
            wallet: {
                sid: null,
                name: '',
                nickname: '',
                zipCode: '',
                tokenId: null,
                tokenType: null,
                card: null,
                checkAccount: null,
                save: false
            },
            paymentType: '',
            pmtDate: '',
            contact: {
                email: '',
                phoneNumber: '',
                save: false,
            },
            custom: {
                accountNumber: '',
                amount: 0,
                invoiceNumber: '',
            },
            customPayNote: '',
        };
        this.shortPays = [];
        this.convenienceFees = [];
        this.defaultConvenienceFees = '';
        this.paymentId = '';
        this.paymentDate = '';
        this.paymentMethod = '';
        this.paymentMethod2 = '';
        this.convenienceFeeObj = {};
        this.cardReview = '';
        this.invoicePaymentDate = '';
        this.frmBillSubmitted = false;
        this.response = {};
        this.frmPayMethodSubmitted = false;
        this.invoiceValid = [];
        this.cardErr = {
            checkname: {
                flag: false,
                msg: ''
            },
            ccnumber: {
                flag: false,
                msg: ''
            },
            ccexp: {
                flag: false,
                msg: ''
            },
            cvv: {
                flag: false,
                msg: ''
            },
            checkaba: {
                flag: false,
                msg: ''
            },
            checkaccount: {
                flag: false,
                msg: ''
            },
        };
        this.validUsPhoneNumber = true;
        this.keypadDataLocked = false;
        this.customPay = paymentHubComponent.payloadData.customPay ?? false;
    }

    ngOnInit(): void {
        this.username = localStorage.getItem(PaymentPlanDefaults.CONSTANT_USERNAME);
        this.transactionId = localStorage.getItem(PaymentPlanDefaults.CONSTANT_TRANSACTION_ID);
        this.loadDefaults(this.transactionId);
    }

    private loadAccounts(): void {
        this.customerService.accounts(this.transactionId).subscribe(res => {
            if (res.status != 200) {
                alert(res.body);
                return;
            }
            this.accounts = res.body;
        }, err => {
            console.log(err);
            alert(err.error.message);
        });
    }

    loadDefaults(transactionId: string) {
        this.paymentHubService.defaults(transactionId).subscribe(res => {
            if (res.status !== 200) {
                alert(res.body);
                return;
            }
            this.defaultSettings = res.body;
            this.adocsBillingId = this.paymentHubComponent.payloadData.billerId;

            this.loadWallets();
            this.loadInvoices();
            this.loadBranding();
            this.loadAccounts();
            this.loadPendingPayments();
        }, err => {
            console.log(err);
            alert(err.error.message);
        });
    }

    loadBranding() {
        this.paymentHubService.branding().subscribe(res => {
            if (res.status != 200) {
                alert(res.body);
                return;
            }
            this.brands = res.body;
            if (this.brands) {
                this.LABEL_ACCOUNT_NUMBER = this.getText('2', 'Account Number');
                this.LABEL_INVOICE_DATE = this.getText('4', 'Invoice Date');
                this.LABEL_INVOICE_NUMBER = this.getText('3', 'Invoice Number');
                this.LABEL_ACCOUNT_NAME = this.getText('1', 'Name');
                this.LABEL_CUSTOMER = this.getText('5', 'Customer');
                this.LABEL_TERMS = this.getText('6', 'Terms & Conditions');

                this.MESSAGE_OVERPAY_WARNING = this.getText('msg_overpay_warning', 'Payment amount is greater than the amount due');
            }
        }, err => {
            console.log(err);
            alert(err.error.message);
        });
    }

    getText(label: string, defaultValue: string): string {
        const val = this.brands.find(x => x.dbId == label);
        return val == null || val == undefined ? defaultValue : val.text;
    }

    changePaymentMethod(type) {
        this.selectedPaymentMethod = type;
        if (this.selectedPaymentMethod != 'wallet') {
            this.paymentData.wallet.sid = null;
        }
        this.ref.detectChanges();
    }

    selectPaymentMethod() {
        if (this.selectedPaymentMethod == 'wallet') {
            this.walletPayment();
        } else {
            this.toggleScreen(this.selectedPaymentMethod);
        }
    }
    public displayLoadingImage(){
        this.onSubmitLoader = true;
        this.ref.detectChanges();
    }

    public disableLoadingImage(){
        this.onSubmitLoader = false;
        this.ref.detectChanges();
    }

    public loadCollectJS() {
        this.ref.detectChanges();

        CollectJS.configure({
            paymentSelector: '#collectJsSubmissionTrigger',
            variant: 'inline',
            styleSniffer: true,
            validationCallback: (field: string | number, status: any, message: any) => {
                if (status) {
                    this.cardErr[field] = {
                        flag: false,
                        msg: ''
                    };
                } else {
                    this.cardErr[field] = {
                        flag: true,
                        msg: message
                    };
                }
                console.log(this.cardErr);
                this.ref.detectChanges();
            },
            timeoutDuration: 10000,
            timeoutCallback: () => {
                this.disableLoadingImage();
                console.log('The tokenization didn\'t respond in the expected timeframe.  This could be due to an invalid or incomplete field or poor connectivity');
            },
            fieldsAvailableCallback: () => {
                console.log('Collect.js loaded the fields onto the form');
            },
            callback: (response) => {
                console.log(response);
                this.handleNmiResponseAndContinue(response);
            },
            fields: this.collectJSFields
        });

        this.startCollectJsPaymentRequest();
        this.ref.detectChanges();
    }


    startCollectJsPaymentRequest() {
        CollectJS.startPaymentRequest();
    }


    handleNmiResponseAndContinue(response: any) {
        this.paymentData.wallet.tokenId = response.token;
        this.paymentData.wallet.tokenType = 'COLLECT_JS';
        this.paymentData.wallet.sid = null;
        // clear fields
        this.paymentData.wallet.checkAccount = null;
        this.paymentData.wallet.card = null;
        this.paymentData.wallet.name = response.check.name;
        if (response.card.number != null && response.card.number != ''){
            this.paymentMethod = 'Card Number: ' + response.card.number;
            this.paymentMethod2 = '';
            this.paymentData.wallet.card = {
                cardNumber: response.card.number,
                expDate: response.card.exp
            };
            this.paymentData.paymentType = 'card';
            this.isCcPayment = true;
        } else if ((response.check.aba != null && response.check.aba != '')  || (response.check.account != null && response.check.account != '')) {
            this.paymentMethod = 'Account Number: ' + response.check.account;
            this.paymentMethod2 = 'Routing number: ' + response.check.aba;
            this.paymentData.wallet.checkAccount = {
                routingNumber: response.check.aba,
                accountNumber: response.check.account,
                businessAccount: this.achBusinessAccount,
                bankName: ''
            };
            this.paymentData.paymentType = 'check';
            this.isCcPayment = false;
        } else{
            console.log('Found a payment that did not have a correct payment type ');
            this.paymentData.paymentType = 'review'; // Assignment did not happen correctly. Needs reviewed by a dev
            this.isCcPayment = false;
        }
        this.disableLoadingImage();
        this.updateTotalAmountWithConvenienceFees();
        this.toggleScreen('reviewPay');
    }


    keypadPayment() {
        // THIS WILL NEED TO BE MADE A SWITCH IN THE FUTURE
        if (this.paymentHubComponent.keypadType === 'M100') {
            this.paymentData.wallet.tokenType = 'KEYPAD_M100_M130_KEYED_DATA';
        }

        this.paymentMethod = 'Keypad';
        this.paymentMethod2 = '';
        this.isCcPayment = true;
        this.paymentData.paymentType = 'card';

        this.updateTotalAmountWithConvenienceFees();
        this.disableLoadingImage();
        this.toggleScreen('reviewPay');
    }


    walletPayment() {
        this.paymentData.wallet.tokenId = null;

        for (const wallet of this.wallets) {
            if (wallet.sid === this.paymentData.wallet.sid) {
                if (wallet.ccNumber){
                    this.paymentMethod = 'Card number: ' + wallet.ccNumber;
                    this.paymentMethod2 = '';
                    this.isCcPayment = true;
                } else {
                    this.paymentMethod = 'Account number: ' + wallet.accountNumber;
                    this.paymentMethod2 = 'Routing number: ' + wallet.routingNumber;
                    this.isCcPayment = false;
                }

                this.paymentData.paymentType = '';
                this.updateTotalAmountWithConvenienceFees();
                this.toggleScreen('reviewPay');
            }
        }
    }


    public getSaveWalletTooltip(){
        let tooltipMessage = '';
        if (this.isFutureDatedPayment()){
            tooltipMessage = 'A wallet must be created for future dated payments.';
        } else {
            tooltipMessage = '';
        }

        return tooltipMessage;
    }

    loadPendingPayments() {
        if (this.paymentData.invoices.length <= 0) return;

        const locationId = this.getFirstLocationIdFromPayloadData();

        const temp = this.paymentData.invoices[0].accountNumber;
        for (const invoice of this.paymentData.invoices) {
            if (invoice.accountNumber != temp) {
                this.singularAccountNumber = '-1';
            } else {
                this.singularAccountNumber = invoice.accountNumber;
            }
        }
        if (this.singularAccountNumber != '-1') {
             this.operationService.findPendingPayments(this.singularAccountNumber, this.adocsBillingId, locationId).subscribe(res => {
                if (res.status != 200) {
                    alert(res.body);
                    return;
                }
                this.pendingPayments = res.body;
            }, err => {
                console.log(err);
                alert(err.error.message);
            });
        }
    }

    getFirstLocationIdFromPayloadData(): string  {
        let payerLocation = 'NO LOCATION FOUND';
         for (const customer of this.paymentHubComponent.payloadData.customers) {
         for (const account of customer.accounts) {
                 if (account.location && account.location !== '') {
                 payerLocation =  account.location;
                 break;
             }
         }
         if (payerLocation !== 'NO LOCATION FOUND') {
            break;
           }
         }
        return payerLocation;

     }

    checkForPendingPayment(type: any) {
        if (this.pendingPayments.length > 0) {
            this.toggleScreen('pendingpayment');
        } else {
            this.frmBillSubmitted = true;
            if (type.form.valid) {
                this.toggleScreen('paymethod');
            }
        }
    }

    resetAllSystemAndUserModifiedValues() {
        // CONVENIENCE FEE RESET
        this.applicableConvenienceFees = false;
        this.totalAmount = this.totalAmountBeforeFees;

        // KEYPAD VIEW RESET
        this.keypadDataLocked = false;
        this.paymentData.wallet.name = '';
        this.paymentData.wallet.tokenId = null;
        this.paymentData.wallet.zipCode = '';
        this.paymentData.wallet.nickname = '';
        this.paymentData.wallet.save = false;

        this.invoicePaymentDate = moment(new Date(this.paymentData.paymentDate.year,
            this.paymentData.paymentDate.month - 1,
            this.paymentData.paymentDate.day)).format('MM/DD/YYYY');
    }


    toggleScreen(type: any) {
        this.type = type;

        if (type === 'paymethod') {
            this.resetAllSystemAndUserModifiedValues();
        }

        if (type === 'card' && this.paymentHubComponent.adminUserWithKeypadEnabled()) {
            this.paymentData.wallet.save = this.isFutureDatedPayment();
            this.type = 'keypad';
        } else
        if (type === 'card' || type === 'bank') {
            this.paymentData.wallet.save = this.isFutureDatedPayment();

            this.collectJSFields = {
                checkname: {
                    placeholder: this.type === 'card' ? 'Name on Card' : 'Name on Account',
                    selector: '#ccName'
                },
                ccnumber: {
                    placeholder: '0000 0000 0000 0000',
                    selector: '#ccNumber'
                },
                ccexp: {
                    placeholder: '00/00',
                    selector: '#ccExp'
                },
                cvv: {
                    placeholder: '000 or 0000',
                    selector: '#cvv'
                },
                checkaba: {
                    placeholder: 'Routing Number',
                    selector: '#routingNo'
                },
                checkaccount: {
                    placeholder: 'Account Number',
                    selector: '#acNumber'
                }
            };

            this.loadCollectJS();
        }

        this.ref.detectChanges();
    }

    loadInvoices() {
        for (const customer of this.paymentHubComponent.payloadData.customers) {
            this.paymentData.contact.email = customer.email;
            this.paymentData.contact.phoneNumber = customer.phoneNumber;
            for (const account of customer.accounts) {
                if (this.customPay) {
                    this.paymentData.custom.accountNumber = account.accountNumber;
                    break; // Exit after first empty account found
                }

                for (const invoice of account.invoices) {
                        const inv = {
                            accountNumber: account.accountNumber,
                            invoiceNumber: invoice.invoiceNumber,
                            uniqueDocId: invoice.uniqueDocId,
                            name: account.name,
                            invoiceDate: invoice.invoiceDate,
                            dueDate: invoice.dueDate,
                            amountDue: invoice.amountDue.toFixed(2),
                            amount: invoice.amountDue.toFixed(2) < 0 ? 0.00 : invoice.amountDue.toFixed(2),
                            shortPay: {
                                comment: '',
                                sid: null
                            },
                        };
                        this.paymentData.invoices.push(inv);
                    }
            }
        }
        // load shortpay
        this.operationService.paymentDefaults(this.transactionId, 2).subscribe(
            res => {
                if (res.status != 200) {
                    alert(res.body);
                }
                for (const data of res.body) {
                    this.shortPays.push(data);
                }
                const other = {
                    sid: 0,
                    text: 'Other'
                };
                this.shortPays.push(other);
            }, err => {
                console.log(err);
                alert(err.error.message);
            }
        );

        this.operationService.paymentDefaults(this.transactionId, 1).subscribe(
            res => {
                if (res.status != 200) {
                    alert(res.body);
                }
                for (const data of res.body) {
                    this.convenienceFees.push(data);
                    this.defaultConvenienceFees = res.body[0].sid;
                    this.paymentData.convenienceFee.sid = res.body[0].sid;
                }
            }, err => {
                console.log(err);
                alert(err.error.message);
            }
        );

        console.log(this.paymentData);
        this.getTotalAmount();
    }

    convertToFloat(price: any, settings: any, dueAmt: any) {
        this.ref.detectChanges();
        if (Number(price) <= 0) {
            return '0.00';
        } else {
            if (!settings.allowShortPay) {
                if (Number(price) < dueAmt) {
                    alert('Short pay not allowed');
                    return (Number(dueAmt).toFixed(2));
                }
            }
            if (!settings.allowOverpay) {
                if (Number(price) > dueAmt) {
                    alert('Over pay not allowed');
                    return (Number(dueAmt).toFixed(2));
                }
            }
            return (Number(price).toFixed(2));
        }
    }

    compareShortpayAmount(price: any, dueAmt: any) {
        if (Number(price) <= 0) {
            return false;
        } else {
            if (Number(price) < dueAmt) {
                return true;
            }
            else {
                return false;
            }
        }
    }

    compareOverpayAmount(price: any, dueAmt: any) {
        if (Number(price) <= 0) {
            return false;
        } else {
            if (Number(price) > dueAmt) {
                return true;
            }
            else {
                return false;
            }
        }

    }

    public getPaymentDate(){
        return moment(new Date(this.paymentData.paymentDate.year, this.paymentData.paymentDate.month - 1,
            this.paymentData.paymentDate.day)).format('MM/DD/YYYY');
    }

    public isFutureDatedPayment(){
        return moment(new Date(this.paymentData.paymentDate.year, this.paymentData.paymentDate.month - 1,
            this.paymentData.paymentDate.day)).diff(moment()) > 0;
    }

    public isValidUsPhoneNumber(phoneNumber: any){
        const regexp = new RegExp('^\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}$');
        const plainPhoneNumberRegexp = new RegExp('^[0-9]{10}$');
        // if empty then consider it to be a valid state
        if (phoneNumber.length === 0){
            this.validUsPhoneNumber = true;
        }else{
            this.validUsPhoneNumber = regexp.test(phoneNumber) || plainPhoneNumberRegexp.test(phoneNumber);
        }

        return this.validUsPhoneNumber;
    }

    doPayment() {
        this.displayLoadingImage();
        this.paymentData.pmtDate = moment(new Date(this.paymentData.paymentDate.year, this.paymentData.paymentDate.month - 1, this.paymentData.paymentDate.day)).format('YYYY-MM-DD');
        this.paymentData.pmtDate = moment(new Date(this.paymentData.paymentDate.year, this.paymentData.paymentDate.month - 1, this.paymentData.paymentDate.day)).format('YYYY-MM-DD');
        this.paymentData.contact.phoneNumber = this.paymentData.contact.phoneNumber.replace(/\D/g, '');

        if (this.customPay) {
            this.executeCustomPay();
        } else {
            this.executeTraditionalPay();
        }
    }

    executeCustomPay() {
        const customPayPostData = {
            paymentDate: this.paymentData.pmtDate,
            convenienceFee: this.applicableConvenienceFees ? this.paymentData.convenienceFee : null,
            raws: [this.paymentData.custom],
            wallet: this.paymentData.wallet,
            contact: this.paymentData.contact,
            card: this.paymentData.card,
            check: this.paymentData.check,
            paymentType: this.paymentData.paymentType,
            customPayNote: this.paymentData.customPayNote
        }
        console.log('Sending CustomPay Request:', JSON.stringify(customPayPostData));
        this.operationService.customPay(this.transactionId, customPayPostData).subscribe(
            res => {
                if (res.status != 200) {
                    alert(res.body);
                }
                const data = res.body;
                res.body.submittedDate = moment(data.submittedAt).format('MM/DD/YYYY');
                res.body.submittedTime = moment(data.submittedAt).format('h:mm a') + ' EST'; // the time from the API call comes in EST always
                this.response = res.body;
                this.disableLoadingImage();
                this.toggleScreen('confirmationPage');
            }, err => {
                this.disableLoadingImage();
                console.log('CustomPay Payment failed',err);
                const errorMessage = err?.error?.message || err?.message || 'An unknown error occurred. Please try again.';
                alert(errorMessage);
            }
        );
    }

    executeTraditionalPay() {
        const postData = {
            paymentDate: this.paymentData.pmtDate,
            convenienceFee: this.applicableConvenienceFees ? this.paymentData.convenienceFee : null,
            raws: this.paymentData.invoices,
            wallet: this.paymentData.wallet,
            contact: this.paymentData.contact,
            card: this.paymentData.card,
            check: this.paymentData.check,
            paymentType: this.paymentData.paymentType
        };

        this.operationService.payment(this.transactionId, postData).subscribe(
            res => {
                if (res.status != 200) {
                    alert(res.body);
                }
                const data = res.body;
                res.body.submittedDate = moment(data.submittedAt).format('MM/DD/YYYY');
                res.body.submittedTime = moment(data.submittedAt).format('h:mm a') + ' EST'; // the time from the API call comes in EST always
                this.response = res.body;
                this.disableLoadingImage();
                this.toggleScreen('confirmationPage');
            }, err => {
                this.disableLoadingImage();
                console.log(err);
                alert(err.error.message);
            }
        );
    }

    updateInvoiceAmount(invoice: any){
        console.log('Invoice amount: ' + invoice.amount + ' invoice amount due: ' + invoice.amountDue);
        if (!this.paymentHubComponent?.defaultSettings?.settings.allowShortPay && invoice.amount < invoice.amountDue){
            invoice.amount = invoice.amountDue;
        }

        if (!this.paymentHubComponent?.defaultSettings?.settings.allowOverpay && invoice.amount > invoice.amountDue){
            invoice.amount = invoice.amountDue;
        }
    }

    getTotalAmount() {
        this.totalAmount = 0;

        if (this.paymentData.invoices.length > 0) {
            for (const invoice of this.paymentData.invoices) {
                if (!isNaN(Number(invoice.amount))) {
                    this.totalAmount = Number(this.totalAmount) + Number(invoice.amount);
                }
            }
        } else {
            if (this.paymentData.custom.amount == null) {
                this.paymentData.custom.amount = 0;
            }
            this.totalAmount = this.paymentData.custom.amount;
        }

        this.totalAmount = this.totalAmount.toFixed(2);
        this.totalAmountBeforeFees = this.totalAmount;

        this.ref.detectChanges();
    }

    updateTotalAmountWithConvenienceFees(){
        this.totalApplicableConvenienceFees = 0;

        if (this.defaultSettings.settings.convenienceFee) {
            for (const data of this.convenienceFees) {
                if (data.sid == this.paymentData.convenienceFee.sid) {
                    this.convenienceFeeObj = data;

                    if ((this.isCcPayment && data.forCard === 'YES') || (!this.isCcPayment && data.forAch === 'YES')) {
                        this.totalApplicableConvenienceFees = Number(this.totalApplicableConvenienceFees) + Number(data.value);
                    }
                }
            }
        }

        if (this.totalApplicableConvenienceFees > 0){
            this.totalAmount = Number(this.totalApplicableConvenienceFees) + Number(this.totalAmount);
            this.totalAmount = this.totalAmount.toFixed(2);
            this.applicableConvenienceFees = true;
        }

        this.ref.detectChanges();
    }

    private loadWallets(): any {
        this.operationService.wallets(this.transactionId).subscribe(res => {
            if (res.status !== 200) {
                alert(res.body);
                return;
            }
            this.wallets = res.body;
        }, err => {
            console.log(err);
            alert(err.error.message);
        });
    }

    printPage() {
        window.print();
    }


    // KEYPAD FUNCTIONALITY

    lockKeypadDataFieldIfInputValid() {
        // THIS WILL NEED TO BE MADE A SWITCH IN THE FUTURE
        if (this.paymentHubComponent.keypadType === 'M100') {
            if (this.paymentData.wallet.tokenId.length === 160) {
                this.keypadDataLocked = true;
                this.ref.detectChanges();
            }
        }
    }
}
